import { useSuspenseQuery } from '@tanstack/react-query'

import type { BusinessItem } from 'src/features/business/shared/schemas/business-item'
import { getRequest } from 'src/lib/api-client'

interface SharedBusinessesParams {
  userId: number
  skip?: number
  limit?: number
}

const getSharedBusinesses = async ({
  userId,
  skip = 0,
  limit = 25,
}: SharedBusinessesParams): Promise<BusinessItem[]> => {
  try {
    const queryParams = new URLSearchParams()
    queryParams.append('other_user_id', userId.toString())
    queryParams.append('skip', skip.toString())
    queryParams.append('limit', limit.toString())

    const response = await getRequest<BusinessItem[]>(`/business/me/shared-with?${queryParams.toString()}`)

    if (!response) {
      return []
    }

    return response
  } catch (error) {
    console.error(error)
    return []
  }
}

export const useSharedBusinesses = (userId: number, params?: Omit<SharedBusinessesParams, 'userId'>) => {
  return useSuspenseQuery<BusinessItem[]>({
    queryKey: ['shared-businesses', userId, params?.skip ?? 0, params?.limit ?? 25],
    queryFn: () => getSharedBusinesses({ userId, ...params }),
  })
}
